import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-energy/15 bg-navy-light py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxkvik8ui7s">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop742ryb3le">I {totalBonuses} <span className="text-gold" data-id="element-21" data-mp="15pw2z0yk0oxw">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-energy/25 bg-navy-card shadow-lg" data-id="element-22" data-mp="15njes627dice">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-aqua/10 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="1eo7rmxfv1cnp" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-aqua/40 bg-navy text-energy" data-id="element-24" data-mp="2jhctss7hj3y8">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ogg16jaxtm9d" />
                </span>
                <div data-id="element-26" data-mp="1quio51fbu94t">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-27" data-mp="1qv1t7hjvp31f">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-cream" data-id="element-28" data-mp="1vueie8y82m76">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-haze" data-id="element-29" data-mp="25qhsc0zbfp4o">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-navy px-6 py-6 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-30" data-mp="3c621xb6yk9jh">
          <div data-id="element-31" data-mp="1h2c7n680wmkg">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-haze" data-id="element-32" data-mp="1h1u6bv6i7i5o">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-haze line-through decoration-gold decoration-2" data-id="element-33" data-mp="1c6ol6ykxe7in">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="1m39ptit19gly">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-haze" data-id="element-35" data-mp="ycnt2nohbir9">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-gold" data-id="element-36" data-mp="teckeg9x7eam">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="175hc8w71r2ae" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}